module.exports = __webpack_public_path__ + "img/flaticon.d442db12.svg";